import { useEffect, useState } from "react";

const STYLE_URL = "https://www.storydoc.com/assets/editor/css/swiper.min.css";
const SCRIPT_URL = "https://www.storydoc.com/assets/editor/js/swiper.min.js";

export const useLoadSwiper = () => {
  "use no memo";
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (window.Swiper) {
      setIsLoaded(true);
      return;
    }

    const loadSwiper = async () => {
      if (!document.head.querySelector(`[href="${STYLE_URL}"`)) {
        const style = document.createElement("link");
        style.href = STYLE_URL;
        style.rel = "stylesheet";
        document.head.appendChild(style);
        style.onerror = () => setIsLoaded(false);

        const script = document.createElement("script");
        script.src = SCRIPT_URL;
        script.async = true;
        document.body.appendChild(script);
        script.onerror = () => setIsLoaded(false);
      }

      const loaded = await verifyIfSwiperExists();
      setIsLoaded(loaded);
    };

    loadSwiper();
  }, []);

  return isLoaded;
};

const verifyIfSwiperExists = async (): Promise<boolean> => {
  if (window.Swiper) {
    return true;
  }

  let count = 0;
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      if (count >= 600) {
        clearInterval(interval);
        return resolve(false);
      }
      if (window.Swiper) {
        clearInterval(interval);
        return resolve(true);
      }
      count++;
    }, 100);
  });
};
